const About = () => (
  <div className="about">
    <h1>About</h1>
    <p>
      CGO, or Czech Games Online is a platform for development and online playing of board games. It is a project of the
      Czech Games Edition board games developer and publisher. From the user interface perspective, it is fairly similar
      to Board Game Arena: it allows players to play a board game in a 2D environment. The system checks that rules are
      followed, and takes care of automation.
    </p>
    <h2>User interface basics</h2>
    The basic user interface comes from the same principles as BGA: the main interaction of the player with the game
    table is a single mouse click. Most notably, this means that drag-and-drop is not used in the game implementations -
    to move a component, first select a component with a single click and then select the destination with a single
    click.
    <h2>Edit mode</h2>
    One of the key features of the system is <b>Edit mode</b>. When you are at a game table, you can turn it on by
    pressing E (or toggling the Edit mode button on the game table page). Edit mode allows you to make any moves and
    adjust components. This is very useful when there happens to be some bug regarding incorrect automation or inability
    to continue playing because of an error.
    <br></br>
    <h2>Errors</h2>
    Sometimes, game might get stuck, and you won’t be able to make a game move according to the rules, always getting an
    error notification. If that happens, try the following steps, in that order:
    <ol>
      <li>If it is a red error, try to click the "do it anyway" button</li>
      <li>Refresh the page</li>
      <li>Using Edit mode, try to adjust parts of the game that you suspect caused the issue.</li>
      <li>Report error via the Discord testing channel. Admins will come and try to resolve the situation.</li>
    </ol>
    <h2>Lobby</h2>
    Any user can create a table. There is no limit to the number of tables one user can create - please, keep this in
    mind and don’t spam the database with too many tables. <br></br>
    Inactive open tables are removed periodically. The table creator can delete both open and mid-game tables from the
    project lobby. Please, delete tables that are inactive or impossible to finish to keep the lobby uncluttered.
    <h2>Table modes</h2>
    There are 2 different table modes you can pick when starting a new table
    <ul>
      <li>
        <b>Standard</b> controls which user plays as which color. The game is created, and can be then started by the
        creator of the table. Any other users can join the table. You can invite other players to a specific table by
        clicking the open table card and sharing the resulting URL address. This mode allows any playing player to use
        Edit mode.
      </li>
      <li>
        <b>Sandbox</b> allows any players to play as any color and use Edit mode. The game starts immediately when the
        table is created, and the table creator must specify which colors will play at the table upon table creation.
      </li>
    </ul>
    <h2>Useful tips</h2>
    <ul>
      <li>
        Press E to turn on Edit mode. In Edit mode, you can move game components without the game rules script
        triggering, so you can fix some mistakes that happened in the game automation.
      </li>
      <li>If game doesn't allow you to make a legal move, turn on "Cheat mode" in table settings</li>
      <li>Read the status bar</li>
      <li>Use the in-game chat to communicate with fellow players (press Enter to start writing)</li>
      <li>Press G to ping a place on the game table</li>
      <li>Press Esc or click a selected component to deselect it.</li>
      <li>Press Alt to turn on zoom lens</li>
      <li>Ctrl+wheel zooms the game in and out</li>
      <li>
        Most importantly: <b>Have fun and thanks for playing!</b>
      </li>
      <li>[TODO: add more tips]</li>
    </ul>
  </div>
);

export default About;
